module.exports = __webpack_public_path__ + "img/daotianLoginBG.2476f393.jpg";